import { isEmpty } from 'lodash';
import { EMPTY_DRAFT_FIELD } from "./constants";
export var isEligTextEmpty = function isEligTextEmpty(eligibility_text) {
  return isEmpty(eligibility_text) || eligibility_text === EMPTY_DRAFT_FIELD;
};